var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('nested-post-sidebar',{key:_vm.group.id,attrs:{"group":_vm.group,"sidebarPosts":_vm.sidebarPosts,"category":_vm.category}}),_vm._v(" "),_c('div',{attrs:{"id":"content-wrapper"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }